<template>
    <div class="news-page">
        <Header></Header> <!-- 头部 -->
        <div class="content home_lists">
            <van-list
                    style="padding-left:20px;padding-right:20px;margin-bottom: 100px;"
                    v-model="joa_loading"
                    :finished="joa_finished"
                    finished-text=" "
                    @load="onLoad"
            >
                <div class="news_lists allshow" style="padding-bottom: 0px;" v-for="(item,index) in joa_list"
                     :id="item.ID">
                    <a :id="'lists_'+item.ID" @click="onSubmitRead(item.ID,item.READ_STATUS)"
                       v-if="item.IS_FOREIGN_URL=='N' && item.IS_ATTACHMENT=='N'"
                       :data-url="WEB_URL+'noticedetail?type=ittopic&id='+item.ID+source">
                        <van-card>
                            <div slot="title" class="ntile">
                                <div :id="'read_'+item.ID" class="pl15">
                                    <span v-if="item.READ_STATUS == 'Y'" class="dot"></span>
                                    <span v-else class="dot red-dot"></span>
                                    {{item.TITLE}}
                                </div>
                            </div>
                            <div slot="tags" class="mt5 mb10">
                                <span class="left c999">{{item.KIND_NAME}}</span>
                                <span class="right c999">{{Common.toTimeDate(item.PUBLICDATE)}}</span>
                            </div>
                        </van-card>
                    </a>
                    <a :id="'lists_'+item.ID" @click="onSubmitRead(item.ID,item.READ_STATUS)" v-else
                       :data-url="item.DETAIL_URL">
                        <van-card>
                            <div slot="title" class="ntile">
                                <div :id="'read_'+item.ID" class="pl15">
                                    <span v-if="item.READ_STATUS == 'Y'" class="dot"></span>
                                    <span v-else class="dot red-dot"></span>
                                    {{item.TITLE}}
                                </div>
                            </div>
                            <div slot="tags" class="mt5 mb10">
                                <span class="left c999">{{item.KIND_NAME}}</span>
                                <span class="right c999">{{Common.toTimeDate(item.PUBLICDATE)}}</span>
                            </div>
                        </van-card>
                    </a>
                </div>
            </van-list>
            <NoDatas></NoDatas> <!-- 没有数据-->
<!--            <FooterNews></FooterNews> -->
            <!-- 尾部 -->
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        created() {
            this.getData(this.CoreNew.SYSTABLE.ITTOPICS);
        },
        data() {
            return {
                WEB_URL: this.CoreNew.WEB_URL,
                OA_API_URL: this.CoreNew.OA_API_URL,
                CECPORT_IMG_URL: this.CoreNew.CECPORT_IMG_URL,
                URLTOKEN: encodeURIComponent(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))),
                joa_list: [],
                joa_total: 0,
                joa_page: 0,
                joa_loading: false,
                joa_finished: false,
                source: ''
            }
        },
        mounted() {
            if (this.CoreNew.WEB_URL_SOURCE) {
                this.source = '&source=' + this.CoreNew.WEB_URL_SOURCE
            }
        },
        methods: {
            onSubmitRead: function (id, read_status) { //更新阅读状态
                var url = $("#lists_" + id).attr("data-url");
                var a_url = "";
                if (url.indexOf("filePath=") > 0) {
                    let reg = new RegExp(this.CoreNew.JOA_URL + 'redirect?', 'g')//g代表全部
                    var a_url = url.replace(reg, this.OA_API_URL + "joa-business/attach/downloadToPath");
                } else {
                    a_url = url;
                }
                if (read_status == "N") {
                    let json_data = {
                        "ENTITY_CONFIG_ID": this.CoreNew.SYSTABLE.ITTOPICS,
                        "MESSAGE_ID": id,
                        "USER_ID": localStorage.getItem('LS_ADMIN_USER_ID')
                    };
                    axios.post(this.CoreNew.OA_API_IP + "joa-business/joatools/action/697/", json_data, {
                        headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                    }).then(function (response) {
                        var $rs = response.data;
                        if (url.indexOf("filePath=") > 0) {  //附件
                            $("#loading").show();
                            this.Common.onFiles(a_url);
                        } else {
                            window.location.href = a_url; //跳转
                        }
                    }.bind(this)).catch(function (error) {
                        $("#loading").hide();
                        //alert("请求--文章--阅读状态--失败"+error);
                        this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求--文章--阅读状态--失败" + error);//记录错误
                        console.log("请求--文章--阅读状态--失败" + error);
                    });
                } else {
                    //window.location.href=$("#lists_"+id).attr("data-url"); //跳转
                    if (url.indexOf("filePath=") > 0) {
                        $("#loading").show();
                        this.Common.onFiles(a_url);
                    } else {
                        window.location.href = a_url; //跳转
                    }
                }
            },
            onLoad: function () {
                this.getData(this.CoreNew.SYSTABLE.ITTOPICS); //获取数据
            },
            getData: function (nid) {
                //console.log(JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION')));
                this.joa_page++;
                this.joa_loading = true;
                //http://10.1.100.169:8084/joa-business/joatools/action/516/1/20
                //let json_data = {"TYPE":sType,"STATUS":0};
                let json_data = {"TYPE": ""};
                axios.post(this.CoreNew.OA_API_IP + "joa-business/joatools/action/" + nid + "/" + this.joa_page + "/" + this.CoreNew.PAGESIZE + "/", json_data, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    if (response.data.flag == true) {
                        if (response.data.data.total == 0) {
                            this.joa_list = [];
                            this.joa_loading = false;
                            this.joa_finished = true;
                            $(".no-datas").addClass("show");
                        } else {
                            var $rs = response.data
                            $(".no-datas").removeClass("show");
                            this.joa_total = $rs.data["total"];
                            var $list = $rs.data["records"];
                            this.joa_list = this.joa_list.concat($list);
                            // 数据全部加载完成
                            this.joa_loading = false;
                            if (this.joa_list.length != 0 && (this.joa_list.length >= this.joa_total)) {
                                this.joa_finished = true;
                            } else {
                                //this.getData(nid,sType); //获取数据
                            }
                        }
                    }
                }.bind(this)).catch(function (error) {
                    //alert("请求--IT热点--失败"+error);
                    this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')), "请求--IT热点--失败" + error);//记录错误
                    console.log("请求--IT热点--失败" + error);
                });
            }
        }
    };
</script>